import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import './PrivateRoute.css';

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null indicates loading state
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const response = await fetch('/privateZone/token_verification.php', {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          setIsAuthenticated(false);
          return;
        }

        const data = await response.json();
        setIsAuthenticated(data.status === 200);
      } catch (error) {
        console.error('Error verifying token:', error);
        setIsAuthenticated(false);
      }
    };

    verifyToken();
  }, [location]);

  if (isAuthenticated === null) {
    return <div className="spinner"></div>; // Show spinner while token is being verified
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
